module.exports = __webpack_public_path__ + "img/SJ.938e05a9.svg";